import { MapPin, Phone, Clock, Instagram, Facebook } from "lucide-react";
import { Reveal } from "./Reveal";
import { LOGO, INSTAGRAM } from "../../data/site";

export const Footer = ({ onReserve }) => {
  return (
    <footer id="contact" className="relative pt-24 pb-10" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6">
        <Reveal>
          <div className="grid gap-12 md:grid-cols-3 border-b border-[var(--br-gold)]/15 pb-16">
            {/* Brand + CTA */}
            <div>
              <div className="flex items-center gap-3">
                <img src={LOGO} alt="Black Rose Lounge" className="h-11 w-auto" />
                <span className="font-display text-2xl text-[var(--br-cream)]">Black Rose <span className="text-[var(--br-gold)]">Lounge</span></span>
              </div>
              <p className="mt-5 max-w-xs text-sm leading-relaxed text-[var(--br-muted)]">
                Authentic Ethiopian cuisine blended with American flavors, premium cocktails and slow-burning hookah.
              </p>
              <button
                data-testid="footer-reserve-btn"
                onClick={onReserve}
                className="gold-btn mt-7 rounded-full px-7 py-3 text-sm font-semibold"
              >
                Reserve a Table
              </button>
            </div>

            {/* Visit */}
            <div className="space-y-5">
              <p className="overline">Visit</p>
              <a
                href="https://maps.google.com/?q=5815+Seminary+Rd+Falls+Church+VA+22041"
                target="_blank" rel="noreferrer"
                data-testid="footer-address"
                className="flex items-start gap-3 text-[var(--br-cream)] hover:text-[var(--br-gold)] transition-colors"
              >
                <MapPin size={18} className="mt-0.5 text-[var(--br-gold)]" />
                <span className="text-sm leading-relaxed">5815 Seminary Rd,<br />Falls Church, VA 22041</span>
              </a>
              <a href="tel:+12022155658" data-testid="footer-phone" className="flex items-center gap-3 text-[var(--br-cream)] hover:text-[var(--br-gold)] transition-colors">
                <Phone size={18} className="text-[var(--br-gold)]" />
                <span className="text-sm">(202) 215-5658</span>
              </a>
              <div className="flex items-center gap-4 pt-2">
                <a href={INSTAGRAM} target="_blank" rel="noreferrer" aria-label="Instagram" data-testid="footer-instagram" className="grid h-9 w-9 place-items-center rounded-full border border-[var(--br-gold)]/30 text-[var(--br-muted)] hover:text-[var(--br-gold)] hover:border-[var(--br-gold)] transition-colors"><Instagram size={16} /></a>
                <a href="#" aria-label="Facebook" className="grid h-9 w-9 place-items-center rounded-full border border-[var(--br-gold)]/30 text-[var(--br-muted)] hover:text-[var(--br-gold)] hover:border-[var(--br-gold)] transition-colors"><Facebook size={16} /></a>
              </div>
            </div>

            {/* Hours */}
            <div className="space-y-4">
              <p className="overline flex items-center gap-2"><Clock size={13} /> Hours</p>
              <ul className="space-y-2.5 text-sm">
                {["Friday","Saturday","Sunday","Monday","Tuesday","Wednesday","Thursday"].map((d) => (
                  <li key={d} className="flex justify-between text-[var(--br-cream)]">
                    <span className="text-[var(--br-muted)]">{d}</span>
                    <span>5:30 PM – 2 AM</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Reveal>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8 text-xs text-[var(--br-muted)]">
          <p>© {new Date().getFullYear()} Black Rose Lounge. All rights reserved.</p>
          <p>
            Powered by{" "}
            <a
              href="https://webnehtech.com"
              target="_blank"
              rel="noreferrer"
              data-testid="footer-powered-by"
              className="text-[var(--br-gold)] hover:text-[var(--br-gold-soft)] transition-colors"
            >
              webnehtech.com
            </a>
          </p>
          <p className="tracking-widest">FALLS CHURCH · VIRGINIA</p>
        </div>
      </div>
    </footer>
  );
};
